import { useSessionContext } from '@common/hooks';
import {
  EtablissementInfoDto,
  EtablissementProjection,
  useGetAllOrganismeEtablissementsQuery,
} from '@common/services';
import { useMemo } from 'react';

export function useGetEtablissementPrincipal() {
  const { organismeId } = useSessionContext();

  const {
    data: etablissements = [] as EtablissementInfoDto[],
    isLoading,
  } = useGetAllOrganismeEtablissementsQuery({
    id: organismeId,
    projection: EtablissementProjection.INFO,
  }, { skip: !organismeId });

  const etablissementPrincipal = useMemo<EtablissementInfoDto>(
    () => etablissements.find(({ principal }) => principal),
    [etablissements],
  );

  return { etablissementPrincipal, isLoading };
}